import { cn } from "web-design-system";

export function NoData({
  title,
  description,
  className,
}: {
  title: string;
  description?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-2 flex-1 justify-center border border-border bg-card rounded-lg",
        className
      )}
    >
      <span className="text-lg font-semibold">{title}</span>
      <span className="text-sm text-muted-foreground">{description}</span>
    </div>
  );
}
